import { createFileRoute } from "@tanstack/react-router";
import Admin from "@/pages/Admin";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/toaster";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/admin")({
  head: () =>
    pageHead({
      path: "/admin",
      title: "Administration | CMO Partner",
      description: "Espace d'administration CMO Partner.",
      enPath: null,
      noindex: true,
    }),
  component: () => (
    <AuthProvider>
      <Toaster />
      <Admin />
    </AuthProvider>
  ),
});
